import Slider from 'react-slick';
import styled from 'styled-components';
import { breakpoints, colors, text, verticalGutter } from '../../styles';

export default styled(Slider)`
  height: 100%;

  /* add/overwrite slick styles */
  .slick {
    &-slide {
      height: 100%;
      max-height: 100%;
      outline: none !important;
      //padding: 0.5rem 1rem;
      > div {
        height: 100%;
        max-height: 100%;
        width: 100%;
      }
    }
    &-slide * {
      outline: none !important;
    }
    &-list {
      height: 100%;
      max-height: 100%;
    }

    &-track {
      display: flex;
      height: 100%;
      max-height: 100%;
    }

    &-dots.yellow > li.slick-active button:before {
      color: #ffe35e;
    }

    &-dots {
      margin: 0;
      padding: 0;
      list-style: none;
      position: absolute;
      text-align: center;
      bottom: 0;
      left: 0;
      right: 0;

      button {
        border: 0;
        background: transparent;
        display: block;
        outline: none;
        line-height: 0;
        font-size: 0;
        color: transparent;
        padding: 0.5rem;
        cursor: pointer;
        text-align: center;

        &:hover,
        &:focus {
          outline: none;
        }

        &:before {
          content: '\\2022';
          font-size: 2.1rem;
          line-height: 1;
          text-align: center;
          color: #d8d8d8;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
      }

      > li {
        display: inline-block;
        opacity: 0.5;
        &:hover,
        &:focus {
          opacity: 1;
        }
        &.slick-active {
          opacity: 1;
          button:before {
            color: ${colors.primary};
          }
        }
      }
    }

    &-arrow {
      position: absolute;
      top: 48%;
      z-index: 1;
      width: 3rem;
      height: 3rem;
      overflow: hidden;
      border-radius: 50%;
      border: none;
      background: transparent;
      font-size: 1rem;
      cursor: pointer;
      /* mainly for landing page manuals carousel */
      margin-top: ${({ arrowOffset }) =>
        arrowOffset ? `${arrowOffset}` : '-1rem'};

      &:before {
        content: '';
        width: 0.9em;
        height: 0.9em;
        display: block;
        border: 4px solid ${colors.textColor};
        transform: rotate(45deg) translateX(-0.2em);
        margin: 0.5em auto;
        border-width: 4px 4px 0 0;
      }

      &,
      &:before {
        transition: all 0.3s ease;
      }
    }

    &-next {
      left: auto;
      right: ${verticalGutter * -1}rem;
      @media screen and (min-width: ${breakpoints.tablet}) {
        right: 0;
      }
    }

    &-prev {
      left: ${verticalGutter * -1}rem;
      &:before {
        transform: rotate(45deg) translateY(-0.2em) scale(-1);
      }
      @media screen and (min-width: ${breakpoints.tablet}) {
        left: 0;
      }
    }
    // disabled state
    &-disabled {
      cursor: default;
      &,
      &:hover {
        &,
        &:before {
          border-color: ${colors.lightGrey};
        }
      }
    }
  }

  /* namespace'd styles */
  &.carouselslider {
    &--manuals {
      .slick-list {
        width: 89%;
        margin: auto;
        @media only screen and (max-width: ${breakpoints.wideMobile}) {
          width: 100%;
        }
      }
    }

    &--align {
      .slick-slide {
        > div {
          height: 100%;
        }
      }
    }

    // carousel with arrows, make the dots smaller
    &--arrows {
      .slick {
        &-dots {
          button {
            padding-left: 0.4rem;
            padding-right: 0.4rem;
          }
        }
      }
    }
  }

  .carouselslider {
    &__img {
      margin: 0 0 ${verticalGutter / 2}rem;
      img {
        max-width: 100%;
        margin: 0 auto;
      }
    }

    &__content {
      padding: ${verticalGutter / 2}rem;
      font-size: ${text.medium};
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: ${colors.darkBlack};
      }
      h3,
      h4,
      h5,
      h6 {
        margin-bottom: 0.1em;
      }
    }
  }
`;
